<template>
	<footer>
		<ul>
			<li v-for="(footer, index) in footerList" :style="{ borderLeftColor: color }" v-bind:key="'foot_' + index">
				<a :href="href(footer.href)" target="_blank"
					@mouseenter="activeNum = index"
					@mouseleave="activeNum = ''"
					:style="{ color: activeNum === index ? hoverColor : color }">
					{{ footer.name }}
				</a>
			</li>
		</ul>
		<p :style="{ color: color }">Copyright © 2015 - {{new Date().getFullYear()}} kuainkanmanhua.com All Rights Reserved</p>
	</footer>
</template>

<script>
export default {
	name: 'Footbar',
	data() {
		return {
			footerList: [{
				name: '首页',
				href: ''
			}, {
				name: '快看漫画APP',
				href: 'http://www.kkmh.com/'
			}, {
				name: '关于快看',
				href: 'webs/about/us'
			}, {
				name: '用户协议',
				href: 'webs/agreement'
			}],
			activeNum: ''
		}
	},
	props: {
		color: {
			default: '#b8b8b8',
			type: String
		},
		hoverColor: {
			default: '#ffba15',
			type: String
		}
	},
	computed: {
		href(url) {
			return function(url) {
				if (url.indexOf('http') === 0) {
					// 完整域名
					return url
				} else {
					const environment = this.$store.state.app.environment
					let host = window.location.host
					if (environment == 'admin') {
						host = host.replace('author', 'www')
					} else if (environment == 'develop') {
						host = 'author.quickcan.cn'
					}
					return `${ window.location.protocol }//${ host }/${ url }`
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
footer {
	width: 100%;
	padding: 50px 0;
	font-size: 14px;
	text-align: center;
	padding-left: 180px;
	ul {
		display: block;
		margin-bottom: 10px;
		text-align: center;
		li {
			display: inline-block;
			padding: 0 8px 0 9px;
			line-height: 18px;
			border-left-width: 1px;
			border-left-style: solid;
			&:first-child {
				border-left: 0;
			}
		}
	}
}
</style>
